var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnBinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7694 14.0003H4.23098C3.94536 14.0003 3.67144 13.8862 3.46948 13.683C3.26751 13.4799 3.15405 13.2043 3.15405 12.917V3.16699H12.8464V12.917C12.8464 13.2043 12.7329 13.4799 12.5309 13.683C12.329 13.8862 12.0551 14.0003 11.7694 14.0003Z",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3844 10.7503V6.41699",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61584 10.7503V6.41699",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.16699H15",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61507 1H6.3843C6.09868 1 5.82476 1.11414 5.6228 1.3173C5.42083 1.52047 5.30737 1.79602 5.30737 2.08333V3.16667H10.692V2.08333C10.692 1.79602 10.5785 1.52047 10.3766 1.3173C10.1746 1.11414 9.90068 1 9.61507 1Z",
    stroke: "#DB0046",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnBinRed);
export default __webpack_public_path__ + "static/media/icn_btn_bin_red.f3e518309c9f0ed084db7e39b662de58.svg";
export { ForwardRef as ReactComponent };